// Normalise un texte pour des recherches insensibles aux accents et à la casse.
// Exemple : "Pédiatrie" -> "pediatrie", "PÉDIATRIE" -> "pediatrie".
export function normaliserTexte(texte: string): string {
  return texte
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}